export default "__VITE_ASSET__BYKt_OyQ__"